import { render, staticRenderFns } from "./PaymentProcedures.vue?vue&type=template&id=7395f5f8&scoped=true&"
import script from "./PaymentProcedures.vue?vue&type=script&lang=js&"
export * from "./PaymentProcedures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7395f5f8",
  null
  
)

export default component.exports